import React from 'react';

import { Spin, Table, Tooltip } from 'antd';

import MyIcon from 'components/Icon';
import Truncate from 'components/Truncate';
import { enums } from 'helpers';
import ProductStatusTag from 'scenes/Producer/Product/MyProducts/components/ProductStatusTag';
import { TableActionButton } from 'v2/components/Shared/TableActionButton';
import { useIrregularProductVariations } from 'v2/hooks/useIrregularProductVariations';
import type { IProduct } from 'v2/interfaces/product';

const STATUS_COLORS: Record<string, string> = {
  '-moderation': '#4159AD',
  '-pending': '#4159AD',
  '-approved': '#009358',
  '-disapproved': '#dc3f53'
};

type DataChildrenProps = {
  product: IProduct;
  onClickOptions: (product: IProduct, activatedChildren: number) => void;
};

const DataChildren = ({ product, onClickOptions }: DataChildrenProps) => {
  const productVariationsQuery = useIrregularProductVariations(product.id, {
    enabled: true
  });

  const columns = [
    {
      title: 'Produto',
      key: 'product',
      render: (_: any, variation: any) => (
        <div className='flex justify-start max-md:flex-col'>
          <div
            className='mr-3 flex h-[50px] w-[50px] rounded-[3px] border border-[#eee] bg-[#eee] bg-cover bg-center bg-no-repeat'
            style={{ backgroundImage: `url(${variation.image})` }}
          />
          <div>
            <div
              className='text-text-secondary overflow-hidden pr-4 text-ellipsis'
              title={variation.title || 'Desconhecido'}
            >
              <Truncate count={80} final='...'>
                {variation.title || 'Desconhecido'}
              </Truncate>
            </div>
            {!variation.has_children && (
              <div
                className='text-[0.85rem] font-semibold'
                style={{
                  color:
                    STATUS_COLORS[
                      enums.PRODUCT_STATUS_CLASS[variation.moderation_status as keyof typeof enums.PRODUCT_STATUS_CLASS]
                    ]
                }}
              >
                <ProductStatusTag status={variation.moderation_status} productType={variation.type} />
                {variation.charge_type === 'A' && (
                  <Tooltip title='Recorrência' placement='top'>
                    <div className='w-[15px]'>
                      <MyIcon className='icon' name='icon-assinaturas' />
                    </div>
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      title: '',
      key: 'actions',
      align: 'right' as const,
      render: (_: any, variation: any) => (
        <TableActionButton onClick={() => onClickOptions(variation, productVariationsQuery.data?.length)} />
      )
    }
  ];

  return (
    <div style={{ paddingBottom: 0, paddingTop: 0 }}>
      {productVariationsQuery.isLoading && (
        <div className='flex justify-center py-4'>
          <Spin size='small' />
        </div>
      )}
      <Table size='small' dataSource={productVariationsQuery.data} columns={columns} rowKey='id' pagination={false} />
    </div>
  );
};

export default DataChildren;
